
_.isIframed = function() {
    try {
        return window.self !== window.top || window.location.pathname.indexOf('/iframe/') === 0;
    } catch (e) {
        return true;
    }
}

_.iframeUrlPrefix = _.isIframed() ? '/iframe' : ''

_.maybeAddSession = function(url, organization) {
  if (_.isIframed() &&
    (!organization || !organization.auth_user) &&
    !!window.session_id) {
    if (url.indexOf('?') >= 0 && url.indexOf('_session=') >= 0) {
      let parts = url.split('?')
      url = parts[0] + '?' + parts[1].replace(/&_session(\=[^&]*)?(?=&|$)|^_session(\=[^&]*)?(&|$)/, '_session=' + window.session_id)
    } else {
      url += (url.indexOf('?') === -1 ? '?' : '&') + '_session=' + window.session_id
    }
  }
  return url
}

_.extractUpidFromUrl = function(url) {
  let matches = (url+'').match(/\/p\/([0-9a-zA-Z]+)$/)
  if (matches && matches.length == 2) return matches[1]
  return null
}

_.cleanupServerSideElements = function() {
  let el = document.getElementById('server-side-pills')
  if (el) el.remove()
  document.querySelectorAll('.hidden-until-rendered').forEach(el => {
    el.className = el.className.replace('hidden-until-rendered', '')
  })
}

_.buildCartTimer = function(seconds) {
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor(seconds / 3600)
  const hours_left = hours % 24
  const minutes = Math.floor(seconds / 60)
  const minutes_left = minutes % 60
  const seconds_left = Math.abs(seconds) % 60
  const expired = seconds <= 0
  let text = expired ? trans('expired') : `${minutes_left}m ${seconds_left < 10 ? '0' : ''}${seconds_left}s`
  if (hours_left > 0) {
    text = `${hours_left}h ${text}`
  }
  if (days > 0) {
    text = `${days} ${trans('day' + (days > 1 ? 's' : '')).toLowerCase()} ${text}`
  }
  return {
    expired: expired,
    days: days,
    hours: hours,
    minutes: minutes,
    text: text
  }
}

_.loadCanva = function(callback) {
  if (window.canvaApi) {
    callback(window.canvaApi)
    return
  }
  if (!window.canvaApiKey || window.canvaApi !== undefined) return
  window.canvaApi = null
  let script = document.createElement('script');
  script.src = 'https://sdk.canva.com/designbutton/v2/api.js'
  script.onload = () => {
    window.Canva.DesignButton.initialize({
      apiKey: window.canvaApiKey,
    }).then(api => {
      window.canvaApi = api
      callback(window.canvaApi)
    })
  }
  document.body.appendChild(script)
}

// Page block stuff
_.getRowClass = function(item) {
  if (!item.span_row) return null
  let justify = item.h_align || 'center'
  if (justify == 'left') justify = 'start'
  if (justify == 'right') justify = 'end'
  return `row justify-content-${justify}`
}
_.getColClass = function(item) {
  if (['card', 'tile', 'video-tile', 'video-card', 'amilia-program', 'amilia-activity', 'amilia-membership', 'my-account-link', 'staff-login-link', 'form-card', 'document-card', 'location-card', 'package-card', 'am-class-card', 'attendance', 'hero', 'alert', 'tabs', 'table', 'one-column', 'html','audio'].indexOf(item.type) >= 0) {
    if (item.image_percent == 0.25) return 'col-12 col-sm-6 col-lg-4 col-xl-3'
    if (item.image_percent == 0.3333) return 'col-12 col-sm-6 col-xl-4'
    if (item.image_percent == 0.5) return 'col-12 col-sm-6'
    if (item.image_percent == 0.6666) return 'col-12 col-lg-6 col-xl-8'
    if (item.image_percent == 0.75) return 'col-12 col-lg-6 col-xl-9'
    if (item.image_percent == 1.0) return 'col-12'
  }
  return 'col-12'
}